import { useEffect, useState } from 'react';
export default function useBoundingClientRect(ref) {
    const [rect, setRect] = useState(new DOMRect(0, 0, 0, 0));
    useEffect(() => {
        if (ref.current) {
            setRect(ref.current.getBoundingClientRect());
        }
    }, [ref]);
    return rect;
}
//# sourceMappingURL=useBoundingClientRect.js.map